// If an image fails to load replace with an empty svg with 0 height and width

export const imageError = (imageElement: HTMLImageElement) => {
    imageElement.src =
        'data:image/svg+xml,<svg height="0" width="0" xmlns="http://www.w3.org/2000/svg"/>';
    imageElement.style.height = '0';
    imageElement.style.width = '0';
};



// WEBPACK FOOTER //
// ./src/utils/imageError.ts